import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cefeb8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "percentile ml-4" }
const _hoisted_2 = { class: "option" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "option-value" }
const _hoisted_5 = { class: "input-box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sign" }, "%", -1))

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.question.wording), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "number",
            min: "0",
            max: "100",
            pattern: "[1-9]\\d*",
            onFocus: _cache[0] || (_cache[0] = $event => ($event.target.select())),
            onkeydown: "if(event.key==='.' || event.key==='-'){event.preventDefault();}",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.fieldValue) = $event))
          }, null, 544), [
            [_vModelText, _ctx.fieldValue]
          ]),
          _hoisted_6
        ])
      ])
    ])
  ]))
}